import { Modal as ModalMUI, styled } from '@mui/material';

import { useEffect, useMemo } from 'react';

import { MessageBus } from '@app-velocity/message-bus';

import { useModalWrapperContext } from './context/useModalWrapperContext';

const messageBus = new MessageBus('users');

const ModalContainer = styled('div')({
  maxWidth: '100%',
});

export const ModalWrapper = () => {
  const { isWrapperVisible, closeModal, mode, closable } =
    useModalWrapperContext();

  const hideBackdrop = useMemo(
    () => ['fullscreen', 'subview'].includes(mode),
    [mode]
  );

  useEffect(() => {
    const unsubscribeAuthStateChange = messageBus.subscribe('logout', () => {
      closeModal();
    });

    return () => {
      unsubscribeAuthStateChange();
    };
  }, []);

  const handleClose = () => {
    if (!closable) return;
    closeModal();
  };

  return (
    <ModalMUI
      keepMounted
      open={isWrapperVisible}
      onClose={handleClose}
      hideBackdrop={hideBackdrop}
      data-testid="modal-wrapper"
      sx={{
        top: mode === 'subview' ? 55 : 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        zIndex: mode === 'subview' ? 10 : 1600,
        width: '100%',
      }}
    >
      <ModalContainer id="modal-container" />
    </ModalMUI>
  );
};
